// extracted by mini-css-extract-plugin
module.exports = {"tableOfContents":"Innholdsfortegnelse_tableOfContents__R2o0_"};